(ns manatee.admin.task-config.handlers
  (:require [ajax.core :as ajax-code]
            [kee-frame.core :as kf]
            [manatee.admin.app-db :as admin-db]
            [manatee.admin.task-config.app-db :as task-config-db]
            [manatee.ajax :as ajax]
            [manatee.components.notifications.handlers :as notifications]
            [re-frame.core :as rf]
            [taoensso.timbre :as log]))

(defn download-to-browser
  [value file-name application-header]
  (let [blob (js/Blob. #js [value] #js {:type application-header})
        url (js/URL.createObjectURL blob)
        a (js/document.createElement "a")]
    (set! (.-href a) url)
    (set! (.-download a) file-name)
    (.click a)
    (js/URL.revokeObjectURL url)))

(defn task-request-body
  [task-config uploaded-submissions]
  (let [body (js/FormData.)]
    (.append body "task-config" (ajax/edn-blob task-config))
    (when uploaded-submissions
      (.append body "uploaded-submissions" uploaded-submissions))
    body))

(kf/reg-chain
 ::load-task-summary
 (fn load-task-summary
   [_ [task-config-id]]
   {:http-xhrio {:method :get
                 :uri (kf/path-for [:api/task-summary :task-config-id task-config-id])
                 :on-failure [::load-task-summary-failure]
                 :response-format (ajax/edn-response-format)}})
 (fn load-task-summary-success
   [{:keys [db]} [_ summary]]
   {:db (admin-db/set-task-summary db summary)}))

(rf/reg-event-fx
 ::load-task-summary-failure
 (fn load-task-summary-failure
   [_ [_ info]]
   (log/error "Error loading task summary" {:info info})
   {:dispatch [::notifications/add-alert :main
               {:message "Unable to load task summary"
                :type :error}
               :auto-dismiss? false]}))

(kf/reg-event-fx
 ::task-results
 (fn download-results
   [{:keys [db]} [task-config-id]]
   (let [{:keys [task-name]} (task-config-db/get-task-config db task-config-id)]
     {:http-xhrio {:method :get
                   :uri (kf/path-for [:api/task-results :task-config-id task-config-id])
                   :response-format (ajax-code/text-response-format)
                   :on-success [::task-results-success task-name]
                   :on-failure [::task-results-failure]}})))

(rf/reg-event-fx
 ::task-results-success
 (fn download-results-success
   [_ [_ task-name response]]
   (download-to-browser response (str task-name "_task-results.json") "application/json")
   {:dispatch [::notifications/add-alert :main
               {:message "Results are being downloaded"
                :type :info}
               :auto-dismiss? true]}))

(rf/reg-event-fx
 ::task-results-failure
 (fn delete-task-failure
   [_ [_ info]]
   (log/error "Error getting task results" {:info info})
   {:dispatch [::notifications/add-alert :main
               {:message "Unable to get task results"
                :type :error}
               :auto-dismiss? false]}))

(kf/reg-controller ::task-summary
                   {:params (fn [{:keys [handler] :as params}] (when (= handler :manatee.task-config.handlers/task-summary) params))
                    :start (fn [_ctx params]
                             (let [id (get-in params [:route-params :task-config-id])]
                               (rf/dispatch [:manatee.admin.task-config.handlers/load-task-summary id])))})
